import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="left">
        <p> © Copyright Soham kavde. All Rights Reserved  </p>
      </div>
    </footer>
  )
}

export default Footer;
